import { tutorials } from '@/components/tutorial/tutorialSteps'
import { useCoreApi } from '@/composables/useApi'
import { useTutorialStore } from '@/store/tutorial'
import { IIntercomAction, TutorialEventAction } from '@lifk/types'

export function useIntercomActions() {
  const api = useCoreApi()
  const tutorial = useTutorialStore()

  // Must resolve to a concrete id: undefined would leave whichever tour ran last
  const tourIdFor = (action: IIntercomAction) =>
    tutorials.some((t) => t.id === action.ref) ? action.ref : tutorials[0].id

  const consume = async () => {
    if (!tutorial.isSupported) return
    const res = await api
      .get<{ actions: IIntercomAction[] }>('/users/intercom-actions')
      .catch(() => null)
    const actions = res?.data?.actions ?? []
    const handled = actions.filter((a) => a.type === 'tour')
    if (!handled.length) return
    tutorial.start(tourIdFor(handled[0]))
    await Promise.all(
      handled.map((a) =>
        api.delete(`/users/intercom-actions/${a._id}`).catch(() => {})
      )
    )
  }

  const trackTutorial = async (
    action: TutorialEventAction,
    tutorialId: string
  ) => {
    await api
      .post('/users/intercom-actions/tutorial-events', { action, tutorialId })
      .catch(() => {})
  }

  return { consume, trackTutorial }
}
